import { useMe } from './useMe'

/**
 * Per-company gate for Hauler Mode — the Erhverv commercial-waste
 * module (Kunder / Ordrer / Containere / Fakturering).
 *
 * Reads `CompanySettingsType.haulerB2bEnabled` from the `me` payload
 * (`GetMeByProjectIds`, `src/api/auth.ts`). This hook is the single
 * source of truth for the flag on the frontend: the sidebar entry
 * (`NavigationMenu`) and the module's route gate
 * (`src/modules/hauler-mode/routing/index.tsx`) both read it, so a
 * flag-off company neither discovers the module nor reaches it by
 * direct URL. Server-side enforcement is the platform lane's
 * `hauler_platform` access gate (fail-closed); until that is deployed
 * this gate is the only fence.
 *
 * FAIL-SAFE: when the field is missing/undefined (an older backend or
 * a partial cache), the module is treated as OFF — existing customers
 * must never see Hauler Mode surfaces by accident. Distinct from
 * `useHaulerModuleEnabled` (the municipal contractor/hauler module):
 * the two flags gate different modules and never imply each other.
 */
export const useHaulerB2bEnabled = (): boolean =>
  Boolean(useMe()?.company?.companySettings?.haulerB2bEnabled)
